
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import PropTypes from 'prop-types';

import React, { useState } from "react";

import { Stack, Paper, Typography, Grid, Box, Button } from '@mui/material/';
import { Span } from "app/components/Typography";
import { AlertService } from "app/services/alertService";
import { OrderDetailsService } from "app/services/order-details-service";
import { useNavigate } from "react-router-dom";

const columns = [
    { field: 'id', headerName: 'id', hide: true },
    { field: 'skuCode', headerName: 'SkuCode', width: 180 },
    { field: 'skuDescription', headerName: 'Sku Description', width: 260 },
    { field: 'orderQty', headerName: 'orderQty', width: 80 },
    { field: 'packageTypeDescription', headerName: 'packageType', width: 130, },
    { field: 'availableQty', headerName: 'Available Qty', width: 100 },
    { field: 'allocatedQty', headerName: 'Allocated Qty', width: 100 },
    { field: 'allocationStatusDescription', headerName: 'Allocation Status', width: 130 },
    { field: 'outboundStatusDescription', headerName: 'Outbound Status', width: 130 },
    { field: 'pickingStatusDescription', headerName: 'Picking Status', width: 130 },

];

const OrderLineItems = ({ data }) => {
    const navigate = useNavigate();
    const [CanlceOrder, SetCancelOrder] = useState(data.filter(x => x.allocationStatusDescription === 'cancel').length);
    console.log(data.filter(x => x.allocationStatusDescription === 'cancel').length);
    function ModelhandleOk() {


        if (SelectedOrderDetailId === 0 && SelectedOrderDetailId == undefined) {
            AlertService.error('Select Order Detail for re allocation ', { keepAfterRouteChange: true });
        }
        else if (SelectedOrderId === 0 && SelectedOrderId == undefined) {
            AlertService.error('Select Order Id for re allocation ', { keepAfterRouteChange: true });
        }
        else {
            var UpdateOrderdetail = { orderDetailId: 0, orderId: 0 }
            UpdateOrderdetail.orderDetailId = SelectedOrderDetailId;
            UpdateOrderdetail.orderId = SelectedOrderId;
            const response = OrderDetailsService.orderReAllocation(UpdateOrderdetail).then(
                x => {
                    navigate("/outward/order/list");
                }

            ).catch((err) => {
                //AlertService.error(err.message, { keepAfterRouteChange: true });
                console.log(err.message);
            });
        }
        // var myArray = [];

        // if (SelectedPickorderForOveridAcction.length === 0)
        //     AlertService.error('Select Pick List for Assign Piking override Action', { keepAfterRouteChange: true });
        // else if (SelectedPickOverrideAction == undefined || SelectedPickOverrideAction == '')
        //     AlertService.error('Select Pick override Action', { keepAfterRouteChange: true });
        // else if (Remarks === undefined || Remarks === '')
        //     AlertService.error('Select Remarks', { keepAfterRouteChange: true });
        // else {

        //     for (let i = 0; i < SelectedPickorderForOveridAcction.length; i++) {
        //         //selectreceivingforPutawy[i].putAwayAssignedTo = userid;
        //         var UpdatePicker = { pickingId: 0, overrideActionId: 0, remarks: '' }
        //         UpdatePicker.pickingId = SelectedPickorderForOveridAcction[i].id;
        //         //UpdatePicker.isPickOverride = SelectedPickorderForOveridAcction[i].id;
        //         //UpdatePicker.pickOverrideReason = SelectedPickorderForOveridAcction[i].id;
        //         UpdatePicker.overrideActionId = SelectedPickOverrideAction.id;
        //         UpdatePicker.remarks = Remarks;
        //         myArray.push(UpdatePicker);
        //     }




        //     const response = PickService.PickoverrideAction(myArray).then(
        //         x => {
        //             navigate("/outward/order/list");
        //         }

        //     ).catch((err) => {
        //         //AlertService.error(err.message, { keepAfterRouteChange: true });
        //         console.log(err.message);
        //     });
        // }

    }
    const [SelectedOrderDetailId, setSelectedOrderDetailId] = useState([]);
    const [SelectedOrderId, setSelectedOrderId] = useState([]);

    return (
        <div style={{ height: '300px', width: '100%' }}>
            {data.filter(x => x.allocationStatusDescription === 'cancel').length !== 0 ? <Button color="primary" onClick={() => ModelhandleOk()} >
                <Span sx={{ pl: 1, textTransform: "capitalize" }}>Reallocate</Span>
            </Button> : null}
            <DataGrid
                rows={data}
                columns={columns}
                density="compact"
                disableMultipleSelection={true}
                pageSize={100}
                onRowClick={(params) => { setSelectedOrderDetailId(params.row.id); setSelectedOrderId(params.row.orderId) }}
                rowThreshold={0}
                rowsPerPageOptions={[100]}
                components={{ Toolbar: GridToolbar }}
            />


        </div>


    )
}


export default OrderLineItems;